import React from "react";

// Component
import RedeemHistorial from "../components/RedeemHistorial/RedeemHistorial";

export default function RedeemHistory() {
	return <RedeemHistorial />;
}
